import { useMatchMedia } from "@/lib/useMatchMedia";
import { MOBILE_HERO_MAX_WIDTH } from "@/components/sections/hero/heroShared";
import HeroSectionDesktop from "@/components/sections/HeroSectionDesktop";
import HeroSectionMobile from "@/components/sections/HeroSectionMobile";

/**
 * Hero router — desktop (601px+) vs mobile-only hero (≤600px).
 * Embed / device preview: mobile tab → HeroSectionMobile, else desktop.
 */
export default function HeroSection(props) {
  const { embedMode, previewDevice } = props;
  const isMobileViewport = useMatchMedia(`(max-width: ${MOBILE_HERO_MAX_WIDTH}px)`);

  if (embedMode || previewDevice) {
    if (previewDevice === "mobile") {
      return <HeroSectionMobile {...props} embedMode />;
    }
    return <HeroSectionDesktop {...props} />;
  }

  if (isMobileViewport === null) {
    return <HeroSectionDesktop {...props} />;
  }

  return isMobileViewport ? <HeroSectionMobile {...props} /> : <HeroSectionDesktop {...props} />;
}
